import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import Dialog from '@material-ui/core/Dialog'
import { Grid, Paper } from '@material-ui/core'

import { AppStyles, AppTheme } from '../styles/AppTheme'
import { CustomMessageDialogStyles } from '../styles/CustomStyles'
import { AppConfig } from '../AppConfig'
import { UiHelper } from '../common/helpers/UiHelper'
import { SubtaskImagePreview } from './SubtaskImagePreview'
import { AppHelper } from '../helpers/AppHelper'
import { Helper } from '../common/helpers/Helper'


import { Fade, Slide } from '@material-ui/core';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class TaskConsolidateViewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onCloseModal = () => {
    this.props.onClosed()
  }

  renderTaskValue = (iType, values) => {
    if (iType === 'IMAGES' && values && values.length > 0) {
      return (
        <SubtaskImagePreview
          ads={values || []}
        ></SubtaskImagePreview>
      )
    } else if (values && values.length > 0) {
      return <div>{values.join(', ')}</div>
    }
    return <div style={{ color: '#888' }}>N/A</div>
  }

  _getMapedLabel = (label) => {
    if (!this.props.subtaskLabelMap) return label
    const item = this.props.subtaskLabelMap.find(item => item.key === label)
    return item ? item.label : label
  }

  render() {
    const { task, title, isOpen } = this.props
    const { imgSubTasks, nonImgSubTasks } = AppHelper.processSubtasks({ task })
    return (
      <Dialog
        open={isOpen}
        aria-labelledby={title}
        fullWidth={AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='lg'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{title}</div>
          <button
            className={css(Styles.modalCloseButton)}
            onClick={this.onCloseModal}
          >
            {UiHelper.renderImg({ key: 'dialogCloseIcon' })}
          </button>
        </div>
        <div className={css(Styles.modalContent)}>
          <Grid container spacing={2}>
            {nonImgSubTasks && nonImgSubTasks.length > 0 && nonImgSubTasks.map((subtask, index) => {
              return (
                <Grid key={subtask.id || 'subtask_' + index} item className={css(Styles.gridItem)} lg={6} xs={12} sm={12} md={6}>
                  <div className={css(Styles.subtaskTitle)}>{this._getMapedLabel(subtask.iType)}</div>
                  <div className={css(Styles.subtaskValue)}>
                    {this.renderTaskValue(subtask.iType, subtask.values)}
                  </div>
                </Grid>
              );
            })}
            {/* Rejected Info */}
            {task && task.rejectedTs &&
                <Grid key={task.id || '_rejectionReason'} item className={css(Styles.gridItem)} lg={6} xs={12} sm={12} md={6}>
                  <div className={css(Styles.subtaskTitle)}>Rejected On</div>
                  <div className={css(Styles.subtaskValue)}>
                    {Helper.formatTimestamp(task.rejectedTs)}
                  </div>
                </Grid>
            }
            {task && task.rejectionComments &&
                <Grid key={task.id || '_rejectionReason'} item className={css(Styles.gridItem)} lg={6} xs={12} sm={12} md={6}>
                  <div className={css(Styles.subtaskTitle)}>Rejection Comments</div>
                  <div className={css(Styles.subtaskValue)}>
                    {task.rejectionComments}
                  </div>
                </Grid>
            }
          </Grid>
          <Grid container spacing={2}>
            {imgSubTasks && imgSubTasks.length > 0 && imgSubTasks.map((subtask, index) => {
              return (
                <Grid key={subtask.id || 'subtask_' + index} item className={css(Styles.gridItem)} lg={6} xs={12} sm={12} md={6}>
                  <div className={css(Styles.subtaskTitle)}>{this._getMapedLabel(subtask.iType)}</div>
                  <div className={css(Styles.subtaskValue)}>
                    {this.renderTaskValue(subtask.iType, subtask.values)}
                  </div>
                </Grid>
              );
            })}
          </Grid>
        </div>
      </Dialog>
    )
  }
}
const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  modalHeader: {
    padding: '20px 30px 14px 30px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  modalTitle: {
    color: '#000',
    fontSize: '28px',
    fontWeight: '600',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '600px',
  },
  modalCloseButton: {
    position: 'absolute',
    top: '23px',
    right: '30px',
    padding: '0',
    backgroundColor: 'transparent',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    display: 'flex',
  },
  modalContent: {
    paddingTop: '6px',
    paddingLeft: '30px',
    paddingRight: '30px',
    paddingBottom: '30px',
    width: '800px',
    minWidth: '200px',
    '@media (max-width: 1024px)': {
      width: 'auto',
    }
  },
  subtaskTitle: {
    fontSize: 14,
    color: 'rgb(18, 18, 18)',
    margin: '0px 0px 8px',
    fontWeight: 467
  },
  subtaskValue: {
    background: 'rgb(247, 247, 249)',
    color: '#000',
    padding: '10px',
    borderRadius: '8px'
  },
})



// WEBPACK FOOTER //
// ./src/components/TaskConsolidateViewDialog.js